import { signUp, confirmSignUp, resendSignUpCode } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';
import '../styles/signup.css'; 

function SignUp() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');

    const [code, setCode] = useState('');
    const [step, setStep] = useState('SIGN_UP');

    useEffect(() => {
      const pendingConfirmation = sessionStorage.getItem('pendingConfirmation');
      if (pendingConfirmation) {
        const { email: savedEmail, step: savedStep } = JSON.parse(pendingConfirmation);
        setEmail(savedEmail);
        setStep(savedStep);
      }
    }, []);
  
    const handleSignUp = async (e) => {
      e.preventDefault();

      try {
        if (password !== confirmPassword) {
          alert('Passwords do not match. Please try again.');
          return;
        } 

        const { isSignUpComplete, nextStep } = await signUp({
          firstName,
          lastName,
          username: email,
          password,
          options: {
            userAttributes: {
              email,
              given_name: firstName,
              family_name: lastName
          }
          }}
        );
                
        if (nextStep.signUpStep === 'CONFIRM_SIGN_UP') {
          setStep('CONFIRM_SIGN_UP');
          sessionStorage.setItem('pendingConfirmation', JSON.stringify({
            email,
            step: 'CONFIRM_SIGN_UP'
          }));
        }
      } catch (error) {
        if (error.name === 'UsernameExistsException') {
          alert('This email is already registered. Please log in.');
        } else if (error.name === 'InvalidPasswordException') {
          console.log(error)
          alert('Password does not meet the requirements. Your password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character.');
        } else if (error.name === 'EmptySignUpUsername') {
          alert('Please enter a valid email address.');
        } else if (error.name === 'EmptySignUpPassword') {
          alert('Please enter a valid password.');
        } else {
          console.log(error.name);
          alert('An error occurred during sign up. Please try again.');
        }
      }
    };
  
    const handleConfirm = async (e) => {      
      e.preventDefault();
      
      if (!code || code.trim() === '') {
        alert('Please enter the confirmation code');
        return;
      }
      
      try {
        await confirmSignUp({ 
          username: email, 
          confirmationCode: code.trim() // Use trim() to remove whitespace
        });
        setStep('SIGN_UP_COMPLETE');
        sessionStorage.removeItem('pendingConfirmation');
        window.location.href = '/account';
      } catch (error) {
        console.error('Confirmation error:', error);
        alert('Invalid confirmation code. Please try again.');
      }
    };

    const handleResendCode = async () => {
      try {
        await resendSignUpCode({ username: email });
        alert('New confirmation code sent to your email');
      } catch (error) {
        console.error('Resend code error:', error);
        alert('Failed to resend code. Please try again.');
      }
    };

    const handleBackToSignUp = () => {
      setStep('SIGN_UP');
      setCode('');
      sessionStorage.removeItem('pendingConfirmation');
    };
  
    return (
      <div>
        {step === 'SIGN_UP' ? (
          <div className="signup">
            <div className="signup-box">
                <div className='signup-header'>
                    <h1>Sign Up</h1>
                    <p>Create your Grievers and Friends account</p>
                </div>
                <form onSubmit={handleSignUp}>
                  <div className="signup-name">
                      <div className="first-name">
                          <label htmlFor="first-name">First Name</label>
                          <input type="text" id="first-name" value={firstName} onChange={e => setFirstName(e.target.value)} />
                      </div>
                      <div className="last-name">
                          <label htmlFor="last-name">Last Name</label>
                          <input type="text" id="last-name" value={lastName} onChange={e => setLastName(e.target.value)} />
                      </div>
                  </div>
                  <div className="signup-email">
                      <label htmlFor="email">Email</label>
                      <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} />
                  </div>
                  <div className="signup-password">
                      <label htmlFor="password">Password</label>
                      <input type="password" id="password" value={password} onChange={e => setPassword(e.target.value)} />
                  </div>
                  <div className="signup-confirm-password">
                      <label htmlFor="confirm-password">Confirm Password</label>
                      <input type="password" id="confirm-password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
                  </div>
                  <input type="submit" value="Sign Up" className="signup-button" />
                </form>
                <div className="signup-footer">
                    <p>Already have an account? <a href="/login">Log in</a></p>
                </div>
            </div>
          </div>
        ) : (
          <div className="signup">
            <div className="signup-box">
              <div className='signup-header'>
                <h1>Confirm Sign Up</h1>
                <p>We've sent a confirmation code to <strong>{email}</strong>.<br />Check your email and enter the code below.</p>
              </div>
              <form onSubmit={handleConfirm}>
                <div className="signup-email">
                  <label htmlFor="confirmation-code">Confirmation Code</label>
                  <input 
                    id="confirmation-code" 
                    value={code} 
                    onChange={e => setCode(e.target.value)} 
                  />
                </div>
                <button type='submit' className="signup-button">
                  Confirm
                </button>
              </form>
              <div className="signup-footer">
                <p>
                  Didn't receive the code? 
                  <button type="button" onClick={handleResendCode} className="link-button">
                    Resend Code
                  </button>
                </p>
                <br />
                <p>
                  <button type="button" onClick={handleBackToSignUp} className="link-button">
                    Back to Sign Up
                  </button>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
  
  export default SignUp;  